(() => {
  if (!customElements.get('ab-collection-tabs')) customElements.define('ab-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const tabs = [...this.querySelectorAll('[role=tab]')];
      const newest = this.querySelector('[data-newest-url]');
      if (newest) fetch(newest.dataset.newestUrl, {signal:this.abort.signal})
        .then(response => { if (!response.ok) throw new Error('Collection unavailable'); return response.text(); })
        .then(html => {
          const panel = new DOMParser().parseFromString(html, 'text/html').getElementById(newest.id);
          if (panel?.querySelector('.ab-product-card')) newest.innerHTML = panel.innerHTML;
        }).catch(() => {});
      const select = (tab, focus = false) => {
        tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; this.querySelector('#' + t.getAttribute('aria-controls')).hidden = !active; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab), {signal:this.abort.signal});
        tab.addEventListener('keydown', e => {
          const next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
          if (next >= 0) { e.preventDefault(); select(tabs[next], true); }
        }, {signal:this.abort.signal});
      });
      document.addEventListener('shopify:block:select', e => { const tab = tabs.find(t => t.dataset.shopifyEditorBlock?.includes(e.detail.blockId)); if (tab) select(tab); }, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
  if (!customElements.get('ab-wash-capacity')) customElements.define('ab-wash-capacity', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const data = JSON.parse(this.querySelector('script').textContent);
      const textNodes = node => node && typeof node === 'object' ? [node.type === 'text' ? node.value || '' : '', ...(node.children || []).map(textNodes)].join('\n') : '';
      const material = textNodes(data.material);
      // Only explicit dimensions with a KG value from this product's specifications.
      const rows = [...material.matchAll(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*cm\s*[:=]\s*(\d+(?:[.,]\d+)?)\s*kg/gi)];
      const main = this.closest('product-info');
      const update = () => {
        const id = main?.querySelector('form.main-product-form [name=id]')?.value;
        const variant = data.variants.find(v => String(v.id) === id) || data.variants.find(v => v.id === data.selected);
        const size = variant?.title.match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/);
        const matches = size ? rows.filter(r => r[1] === size[1] && r[2] === size[2]) : [];
        const values = [...new Set(matches.map(r => r[3]))];
        const advice = data.advice?.[String(variant?.id)];
        const capacity = advice?.kg || variant?.capacity || data.capacity || (values.length === 1 ? values[0] : '');
        const label = this.querySelector('[data-wash-label]');
        const text = capacity ? 'Aanbevolen wasmachinecapaciteit: ' + String(capacity).replace(/\s*kg\s*$/i,'') + ' kg' : 'Wasmachinecapaciteit: bekijk het waslabel';
        const note = this.querySelector('[data-wash-note]');
        const adviceText = (advice?.estimated ? 'Indicatie op basis van maat en type. ' : '') + (advice?.separate ? 'Was de delen afzonderlijk. ' : '') + 'Volg het waslabel en houd voldoende ruimte in de trommel.';
        if (note && note.textContent !== adviceText) note.textContent = adviceText;
        if (label.textContent !== text) label.textContent = text;
      };
      update(); document.addEventListener('variant:changed', update, {signal:this.abort.signal});
      main?.addEventListener('change', () => requestAnimationFrame(update), {signal:this.abort.signal});
      this.observer = new MutationObserver(update);
      if (main) this.observer.observe(main, {subtree:true,attributes:true,attributeFilter:['value','disabled']});
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
  });
  if (!customElements.get('ab-sticky-buy')) customElements.define('ab-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.abort = new AbortController();
      const main = document.querySelector('product-info[data-main-product]') || document.querySelector('product-info');
      if (!main) return;
      let target = main.querySelector('[data-ap-add]') || main.querySelector('[id^="ProductSubmitButton-"]');
      let form = main.querySelector('form.main-product-form');
      if (!target || !form) return;
      if (this.parentElement !== document.body) {
        this.abort = null;
        document.body.append(this);
        return;
      }
      const button = this.querySelector('button');
      const variants = JSON.parse(this.querySelector('script').textContent);
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency',currency:this.dataset.currency}).format(value/100);
      const sync = () => {
        const currentTarget = main.querySelector('[data-ap-add]') || main.querySelector('[id^="ProductSubmitButton-"]');
        form = main.querySelector('form.main-product-form');
        if (!currentTarget || !form) { this.hidden = true; return; }
        if (currentTarget !== target) { target = currentTarget; this.intersection?.disconnect(); this.intersection?.observe(target); }
        const obstructed = [...document.querySelectorAll('dialog[open],[role="dialog"],subscription-popup:not([hidden]),cart-drawer[open],cart-drawer[active]')].some(el => el.getBoundingClientRect().height > 0 && el.getBoundingClientRect().bottom > 0 && el.getBoundingClientRect().top < innerHeight && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0' && el.getAttribute('aria-hidden') !== 'true');
        const targetRect = target.getBoundingClientRect();
        const targetVisible = targetRect.height > 0 && targetRect.width > 0 && targetRect.top < innerHeight && targetRect.bottom > 0;
        const hideSticky = targetVisible || obstructed;
        const cookie = document.querySelector('#shopify-pc__banner');
        const cookieRect = cookie?.getBoundingClientRect();
        const cookieVisible = cookieRect && cookieRect.height > 0 && cookieRect.top < innerHeight && cookieRect.bottom > 0 && getComputedStyle(cookie).visibility !== 'hidden';
        const offset = cookieVisible ? Math.max(0, innerHeight - cookieRect.top) : 0;
        const bottom = 'calc(' + offset + 'px + env(safe-area-inset-bottom))';
        if (this.style.bottom !== bottom) this.style.setProperty('bottom', bottom, 'important');
        if (this.hidden !== hideSticky) this.hidden = hideSticky;
        const variant = variants.find(v => String(v.id) === form.querySelector('[name=id]')?.value);
        const busy = target.disabled || target.getAttribute('aria-disabled') === 'true' || target.getAttribute('aria-busy') === 'true';
        if (button.disabled !== busy) button.disabled = busy;
        const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
        setText(button, target.matches('[data-ap-add]') ? target.textContent.split(' – ')[0] : busy && variant && !variant.available ? 'Uitverkocht' : 'Aan winkelwagen toevoegen');
        if(variant) { setText(this.querySelector('[data-ab-variant]'), variant.title === 'Default Title' ? '' : variant.title); setText(this.querySelector('[data-ab-price]'), main.querySelector('[data-ap-total]')?.textContent?.trim() || money(variant.price)); }
      };
      button.addEventListener('click', () => {
        sync();
        if (button.disabled) return;
        if (!form.checkValidity()) { form.reportValidity(); form.querySelector(':invalid')?.focus(); return; }
        target.click(); sync();
      }, {signal:this.abort.signal});
      this.intersection = new IntersectionObserver(sync);this.intersection.observe(target);
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; sync(); }); };
      document.addEventListener('scroll', schedule, {passive:true,signal:this.abort.signal});
      window.addEventListener('resize', schedule, {passive:true,signal:this.abort.signal});
      this.observer = new MutationObserver(schedule); this.observer.observe(main,{subtree:true,attributes:true,childList:true,characterData:true});
      document.addEventListener('shopify:section:load', () => { this.disconnectedCallback(); this.connectedCallback(); }, {signal:this.abort.signal});
      document.addEventListener('variant:changed', sync, {signal:this.abort.signal});
      document.addEventListener('close', sync, {capture:true,signal:this.abort.signal});
      this.overlayObserver = new MutationObserver(sync);this.overlayObserver.observe(document.body,{childList:true});
      this.overlayTimer = setInterval(sync, 800);
      document.addEventListener('click', () => requestAnimationFrame(sync), {signal:this.abort.signal});
      sync();
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.intersection?.disconnect();this.observer?.disconnect();this.overlayObserver?.disconnect();clearInterval(this.overlayTimer);cancelAnimationFrame(this.frame);this.frame=null;}
  });
})();
